import * as Sentry from "@sentry/react";
import React from "react";

import MeetingsIntegrations from "./components/MeetingsIntegrations";

import { getFeatureFlagQuery } from "../../../hooks/useFeatureFlag";

import { currentUserQuery, meetingsIntegrationsSettingsQuery } from "../../../api/queries";
import { dataLoader } from "../../../api/queries/dataLoader";

// The consolidated /settings endpoint returns whichever sections are gated on
// for this company + caller, so a single prefetch works for all FF combinations.
export const meetingsIntegrationsSettingsLoader = () => {
	const queries = [meetingsIntegrationsSettingsQuery, getFeatureFlagQuery];

	return dataLoader([[currentUserQuery], queries]);
};

const AdminMeetingsIntegrations = () => {
	return (
		<Sentry.ErrorBoundary fallback={undefined}>
			<MeetingsIntegrations />
		</Sentry.ErrorBoundary>
	);
};

export default AdminMeetingsIntegrations;
